// extracted by mini-css-extract-plugin
export var disabled = "_1e-a";
export var hierarchyLinkGray = "_1e-4";
export var hierarchyLinkUnderline = "_1e-3";
export var hierarchyPrimary = "_1e-0";
export var hierarchySecondary = "_1e-1";
export var hierarchyTertiary = "_1e-2";
export var pressed = "_1e-6";
export var themeAction = "_1e-5";
export var themeDestructive = "_1e-8";
export var themeNormal = "_1e-7";
export var themeSuccess = "_1e-9";